



















import { Prop, Component, Vue } from 'vue-property-decorator'
import { Order } from '@/api/model/order'
import { OrderStatus } from '@/api/types'

@Component
export default class OrderColumnStatus extends Vue {
    @Prop({ required: true }) order!: Order

    colorForStatus(status: string, opacity: number = 1): string {
        switch (status) {
            case OrderStatus.PENDING: return `rgba(247, 131, 35, ${opacity})`
            case OrderStatus.SUCCESSFUL: return `rgba(19, 210, 197, ${opacity})`
            case OrderStatus.UNSUCCESSFUL: return `rgba(235, 89, 140, ${opacity})`
            default: return `rgba(169, 50, 38, ${opacity})`
        }
    }

    get routeToDetail() {
        return {
            name: 'orders_detail',
            params: {
                orderId: this.order.id,
                contactId: this.order.referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }
}
